import { Badge, BadgeSize, BadgeVariant } from "shared/components";

export const BetaBadge = ({
  variant,
  className
}: {
  variant: BadgeVariant;
  className?: string;
}) => {
  return (
    <Badge variant={variant} size={BadgeSize.SM} className={className}>
      Beta
    </Badge>
  );
};
